import { styled } from '@mui/material';

import { Typography } from '@app-velocity/ui';

import { OpenIcon } from '@app-velocity/icons';

import { useLoadingScreen } from '../../hooks/useLoadingScreen';

const QuoteContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 10%',
  color: 'var(--text-heading-color)',
  height: 150,
}));

const Quote = styled(Typography)({
  fontWeight: 600,
  fontSize: 16,
  lineHeight: '22px',
});

const Author = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: 16,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  svg: {
    fill: 'var(--icon-icon-secondary-color)',
  },
}));

export const LoadingQuote = () => {
  const { randomQuote } = useLoadingScreen();

  return (
    <QuoteContainer>
      <Quote>“{randomQuote.quote}“</Quote>
      <Author>
        - {randomQuote.author}{' '}
        <a href={randomQuote.source} target="_blank" rel="noreferrer">
          <OpenIcon />
        </a>
      </Author>
    </QuoteContainer>
  );
};
